/**
 * Checks if the value is of the type SVG
 *
 * @param {*} val
 * @returns {Boolean}
 */

const isTypeSVG = (val) => {
  const type = typeof val === "function" ? val().type : val
  return type === "svg"
}

/**
 * Checks if the the input is a SVG
 *
 * @param {Object} icon
 * @returns {Boolean}
 */

export const isSVG = (icon) => {
  if (!icon) return false
  const type = (icon.props && icon.props.originalType) || icon.type

  return isTypeSVG(type)
}
